export { default as setQueryLogger } from './setQueryLogger';
